<template>
  <div :class="[`x3-24 poppins-normal-thunder-25px`, className || ``]">
    <div class="text-43-2">{{ text1728 }}</div>
    <div class="text-436">{{ text1727 }}</div>
  </div>
</template>

<script>
export default {
  name: "X3102",
  props: ["text1728", "text1727", "className"],
};
</script>

<style>
.x3-24 {
  display: flex;
  gap: 51px;
  margin-left: 67px;
  width: 483px;
}

.text-43-2 {
  height: 38px;
  letter-spacing: 1.25px;
  line-height: normal;
  width: 126px;
}

.text-436 {
  height: 38px;
  letter-spacing: 1.25px;
  line-height: normal;
  width: 302px;
}

.x3-24.x1-59,
.x3-24.x1-60 {
  width: 484px;
}

.x3-24.x1-59 .text-436,
.x3-24.x1-60 .text-436 {
  width: 303px;
}
</style>
